import { AntVDagreLayout } from './antv-dagre';
import { CircularLayout } from './circular';
import { ComboCombinedLayout } from './combo-combined';
import { ConcentricLayout } from './concentric';
import { D3ForceLayout } from './d3-force';
import { D3Force3DLayout } from './d3-force-3d';
import { DagreLayout } from './dagre';
import { ForceLayout } from './force';
import { ForceAtlas2Layout } from './force-atlas2';
import { FruchtermanLayout } from './fruchterman';
import { GridLayout } from './grid';
import { MDSLayout } from './mds';
import { RadialLayout } from './radial';
import { RandomLayout } from './random';
import type { Layout } from './types';

export const registry: Record<string, new (...args: any) => Layout<any>> = {
  circular: CircularLayout,
  concentric: ConcentricLayout,
  mds: MDSLayout,
  random: RandomLayout,
  grid: GridLayout,
  radial: RadialLayout,
  force: ForceLayout,
  d3force: D3ForceLayout,
  'd3-force-3d': D3Force3DLayout,
  fruchterman: FruchtermanLayout,
  forceAtlas2: ForceAtlas2Layout,
  dagre: DagreLayout,
  antvDagre: AntVDagreLayout,
  comboCombined: ComboCombinedLayout,
};
